module.exports = __webpack_public_path__ + "img/20191008155929525.cb71d91d.jpg";